<div class="max-w-4xl mx-auto py-8 px-4">
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-on-surface">データ抽出</h1>
    <p class="text-on-surface-variant mt-1">現場や期間を指定してセンサーの測定履歴をCSV形式でダウンロードします。</p>
  </div>

  <mat-card class="bg-primary-container">
    <mat-card-content class="p-6">
      <form [formGroup]="form" (ngSubmit)="extractData()" class="flex flex-col gap-6">
        
        <!-- 期間選択 -->
        <div>
          <h2 class="text-lg font-medium mb-3">1. 抽出期間を指定（最大31日間）</h2>
          <mat-form-field class="w-full max-w-md" appearance="outline">
            <mat-label>抽出期間</mat-label>
            <mat-date-range-input [rangePicker]="picker" [max]="maxDate">
              <input matStartDate formControlName="from" placeholder="開始日">
              <input matEndDate formControlName="to" placeholder="終了日">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            @if (form.get('from')?.hasError('required') || form.get('to')?.hasError('required')) {
              <mat-error>期間を指定してください</mat-error>
            }
          </mat-form-field>
        </div>

        <!-- 現場選択 -->
        <div>
          <h2 class="text-lg font-medium mb-3">2. 現場を選択</h2>
          <mat-form-field class="w-full max-w-md" appearance="outline">
            <mat-label>現場</mat-label>
            <mat-select formControlName="siteId">
              @for (site of sites(); track site.id) {
                <mat-option [value]="site.id">{{ site.name }}</mat-option>
              }
            </mat-select>
            @if (form.get('siteId')?.hasError('required')) {
              <mat-error>現場を選択してください</mat-error>
            }
          </mat-form-field>
        </div>

        <!-- センサー選択 -->
        @if (form.get('siteId')?.value) {
          <div>
            <h2 class="text-lg font-medium mb-3">3. センサーを選択</h2>
            @if (availableSensors().length > 0) {
              <div class="bg-white rounded border border-gray-200 p-4">
                <div class="mb-2 pb-2 border-b border-gray-100">
                  <mat-checkbox 
                    [checked]="isAllSelected()"
                    [indeterminate]="isSomeSelected()"
                    (change)="toggleAllSensors($event.checked)">
                    すべて選択
                  </mat-checkbox>
                </div>
                <div class="flex flex-col gap-2 max-h-60 overflow-y-auto pl-2">
                  @for (sensor of availableSensors(); track sensor.id) {
                    <mat-checkbox 
                      [checked]="selectedSensors().has(sensor.id)"
                      (change)="toggleSensor(sensor.id, $event.checked)">
                      {{ sensor.categoryName }} ({{ sensor.id }})
                    </mat-checkbox>
                  }
                </div>
              </div>
            } @else {
              <p class="text-on-surface-variant">選択した現場に紐づくセンサーがありません。</p>
            }
          </div>
        }

        <!-- 抽出ボタン -->
        <div class="mt-4 pt-4 border-t border-gray-200">
          <div class="flex items-center gap-4">
            <button 
              matButton="tonal"
              type="submit" 
              [disabled]="!canExtract()">
              <mat-icon>download</mat-icon>
              CSVダウンロード
            </button>
            @if (isExtracting()) {
              <span class="text-sm text-on-surface-variant">データを抽出中...</span>
            }
          </div>
          
          @if (isExtracting()) {
            <mat-progress-bar mode="indeterminate" class="mt-4"></mat-progress-bar>
          }
        </div>
        
      </form>
    </mat-card-content>
  </mat-card>
</div>
